import React from 'react';
export function TrustBar() {
  return <section className="bg-deep-blue py-3" data-id="element-132">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-133">
        <p className="text-white text-sm font-medium" data-id="element-134">
          ⭐ 4.9/5 | +4.500 familias en España ya recuperaron la paz esta semana
        </p>
      </div>
    </section>;
}